import Vue from 'vue'
import Vuex from 'vuex'
import publicationsModule from './modules/publications'
import stocksModule from './modules/stocks'
import customerModule from './modules/customer'
import appModule from './modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // This will throw error when the data is updated incorrectly.
  state: {
    packageVersion: JSON.parse(unescape(process.env.PACKAGE_JSON || '%7Bversion%3A0%7D')).version
  },
  getters: {
    appVersion: (state) => state.packageVersion
  },
  /*
     Modularise the story by their characteristics
  */
  modules: {
    customer: customerModule,
    publications: publicationsModule,
    stocks: stocksModule,
    app: appModule
  }
})
